'use client';

import {
  CaseStudyBody,
  CaseStudyResultsTable,
} from '@/components/case-study/case-study-body';
import { CaseStudyHero } from '@/components/case-study/case-study-hero';
import { CustomerVideos } from '@/components/sections/customer-videos';
import Testimonials from '@/components/sections/testimonials';
import { useTranslation } from '@/lib/i18n/context';

const MoneyGramCaseStudy = () => {
  const { t, isRTL } = useTranslation();
  return (
    <>
      <CaseStudyHero
        customerName="MoneyGram"
        title={
          t.customerStories[
            'How MoneyGram supports 55M customers across 200+ countries'
          ]
        }
        subtitle={
          t.customerStories[
            "Open's AI agent handles 70%+ of support across email and chat for 200+ countries in multiple languages. Customers get instant answers about transfers, payments, and compliance, 24/7."
          ]
        }
        stats={[
          {
            value: isRTL ? '٥٥ مليون' : '55M',
            label: t.customerStories.customers,
          },
          {
            value: isRTL ? '٨٠٪' : '80%',
            label: t.customerStories['Automation rate'],
          },
          {
            value: isRTL ? t.customerStories['All-time high'] : 'ATH',
            label: t.customerStories['CSAT score'],
          },
        ]}
        videoSrc="/home/features/moneygram-shot.mp4"
        videoVariant="ambient"
      />

      <CaseStudyBody
        aside={{
          logoSrc: '/logos/logo-moneygram.svg',
          logoAlt: 'MoneyGram',
          company: t.customerStories['moneygram_company_description'],
          industry: t.customerStories['Financial Services / Remittance'],
          websiteUrl: 'https://www.moneygram.com',
          extras: [
            {
              label: t.customerStories['Global Reach'],
              value: t.customerStories['200+ countries and territories'],
            },
          ],
          keyResults: [
            t.customerStories['• 70%+ automation rate'],
            t.customerStories['• All-time high CSAT score'],
            t.customerStories['• Email, phone, and chat covered'],
            t.customerStories['• 200+ countries, 24/7 support'],
          ],
        }}
      >
        <p>{t.customerStories['moneygram_intro']}</p>

        <h2>{t.customerStories['moneygram_scale_title']}</h2>
        <p>{t.customerStories['moneygram_scale_p1']}</p>
        <p>{t.customerStories['moneygram_scale_p2']}</p>
        <p>{t.customerStories['moneygram_scale_p3']}</p>

        <h2>{t.customerStories['moneygram_solution_title']}</h2>
        <p>{t.customerStories['moneygram_solution_p1']}</p>
        <p>{t.customerStories['moneygram_solution_p2']}</p>
        <p>{t.customerStories['moneygram_solution_p3']}</p>
        <p>{t.customerStories['moneygram_solution_p4']}</p>

        <h3>{t.customerStories['The Results']}</h3>
        <p>{t.customerStories['moneygram_results_intro']}</p>

        <CaseStudyResultsTable
          metricLabel={t.customerStories['Metric']}
          impactLabel={t.customerStories['Impact']}
          rows={[
            {
              metric: t.customerStories['Automation rate'],
              impact: isRTL ? '٨٠٪' : '80%',
            },
            {
              metric: t.customerStories['CSAT score'],
              impact: t.customerStories['All-time high'],
            },
            {
              metric: t.customerStories['Channels covered'],
              impact: t.customerStories['Email, phone, and chat'],
            },
            {
              metric: t.customerStories['Coverage'],
              impact: t.customerStories['200+ countries, 24/7'],
            },
          ]}
        />

        <p>{t.customerStories['moneygram_results_p1']}</p>

        <h2>{t.customerStories['moneygram_impact_title']}</h2>
        <p>{t.customerStories['moneygram_impact_p1']}</p>
        <p>{t.customerStories['moneygram_impact_p3']}</p>
      </CaseStudyBody>

      <CustomerVideos />

      <Testimonials />
    </>
  );
};

export default MoneyGramCaseStudy;
